import { createContext, useContext, useMemo, useState, ReactNode } from 'react'

interface SidebarUIContextValue {
	isMobileOpen: boolean
	openMobileSidebar: () => void
	closeMobileSidebar: () => void
}

const SidebarUIContext = createContext<SidebarUIContextValue | undefined>(undefined)

export function SidebarUIProvider({ children }: { children: ReactNode }) {
	const [isMobileOpen, setIsMobileOpen] = useState(false)

	const value = useMemo(
		() => ({
			isMobileOpen,
			openMobileSidebar: () => setIsMobileOpen(true),
			closeMobileSidebar: () => setIsMobileOpen(false),
		}),
		[isMobileOpen],
	)

	return <SidebarUIContext.Provider value={value}>{children}</SidebarUIContext.Provider>
}

export function useSidebarUI() {
	const context = useContext(SidebarUIContext)
	if (!context) {
		throw new Error('useSidebarUI must be used within a SidebarUIProvider')
	}
	return context
}
